import { useEffect } from "react";
import { Card } from "@/components/Shared/Card";
import { Separator } from "@/components/ui/separator";
import { ConfigTable } from "./ConfigTable";
import { Button } from "@/components/ui/button";
import { useTour } from "@reactour/tour";
import { tourSteps } from "./ConfigTour";
import { HelpCircleIcon } from "lucide-react";
import { Content } from "@/components/ui/ContentArea";

export function ConfigReferenciasPage() {
	const { setIsOpen, setCurrentStep, setSteps } = useTour();

	useEffect(() => {
		if (!setSteps) throw new Error("setSteps is not defined");
		setSteps(tourSteps);
	}, [setSteps]);

	const initTour = () => {
		setIsOpen(true);
		setCurrentStep(0);
	};

	return (
		<Content className="p-5">
			<title>Editar Referencias Consumo</title>

			<Card>
				<div className="flex justify-between" data-tour-id="title">
					<h1 className="text-xl font-bold">Editar Referencias Consumo</h1>
					<Button variant="ghost" size="icon" onClick={initTour}>
						<HelpCircleIcon className="size-6" />
					</Button>
				</div>
				<Separator />
				<ConfigTable />
			</Card>
		</Content>
	);
}
